// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AlertDestinationFormOptionsQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type AlertDestinationFormOptionsQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    slackIntegration?: {
      __typename?: "SlackIntegration";
      id: string;
      availableChannels: {
        __typename?: "SlackChannelList";
        error?: string | null;
        channels: Array<{
          __typename?: "SlackChannel";
          id: string;
          name: string;
        }>;
      };
    } | null;
    pagerdutyIntegration?: {
      __typename?: "PagerdutyIntegration";
      id: string;
      availableServices: Array<{
        __typename?: "PagerdutyService";
        id: string;
        name: string;
      }>;
    } | null;
    memberships: Array<{
      __typename?: "OrganizationMembership";
      id: string;
      email: string;
    }>;
  } | null;
};

export type AlertDestinationFormDetailsQueryVariables = Types.Exact<{
  destinationId: Types.Scalars["ID"]["input"];
}>;

export type AlertDestinationFormDetailsQuery = {
  __typename?: "GraphqlQuery";
  getAlertDestinationDetails: {
    __typename?: "AlertDestination";
    id: string;
    name: string;
    isDefault: boolean;
    permittedToEdit: boolean;
    permittedToDelete: boolean;
    integrations: Array<{
      __typename?: "AlertDestinationIntegration";
      id: string;
      kind: string;
      organizationIntegrationId: string;
      targetId?: string | null;
      targetLabel?: string | null;
    }>;
    members: Array<{
      __typename?: "AlertDestinationMember";
      id: string;
      organizationMembershipId: string;
      email: string;
    }>;
    rules: Array<{
      __typename?: "AlertRule";
      id: string;
      name: string;
      server?: { __typename?: "Server"; name: string } | null;
    }>;
  };
};

export const AlertDestinationFormOptionsDocument = gql`
  query AlertDestinationFormOptions($organizationSlug: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      slackIntegration {
        id
        availableChannels {
          error
          channels {
            id
            name
          }
        }
      }
      pagerdutyIntegration {
        id
        availableServices {
          id
          name
        }
      }
      memberships {
        id
        email
      }
    }
  }
`;

/**
 * __useAlertDestinationFormOptionsQuery__
 *
 * To run a query within a React component, call `useAlertDestinationFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertDestinationFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertDestinationFormOptionsQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useAlertDestinationFormOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertDestinationFormOptionsQuery,
    AlertDestinationFormOptionsQueryVariables
  > &
    (
      | { variables: AlertDestinationFormOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertDestinationFormOptionsQuery,
    AlertDestinationFormOptionsQueryVariables
  >(AlertDestinationFormOptionsDocument, options);
}
export function useAlertDestinationFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertDestinationFormOptionsQuery,
    AlertDestinationFormOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertDestinationFormOptionsQuery,
    AlertDestinationFormOptionsQueryVariables
  >(AlertDestinationFormOptionsDocument, options);
}
// @ts-ignore
export function useAlertDestinationFormOptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertDestinationFormOptionsQuery,
    AlertDestinationFormOptionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AlertDestinationFormOptionsQuery,
  AlertDestinationFormOptionsQueryVariables
>;
export function useAlertDestinationFormOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertDestinationFormOptionsQuery,
        AlertDestinationFormOptionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AlertDestinationFormOptionsQuery | undefined,
  AlertDestinationFormOptionsQueryVariables
>;
export function useAlertDestinationFormOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertDestinationFormOptionsQuery,
        AlertDestinationFormOptionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AlertDestinationFormOptionsQuery,
    AlertDestinationFormOptionsQueryVariables
  >(AlertDestinationFormOptionsDocument, options);
}
export type AlertDestinationFormOptionsQueryHookResult = ReturnType<
  typeof useAlertDestinationFormOptionsQuery
>;
export type AlertDestinationFormOptionsLazyQueryHookResult = ReturnType<
  typeof useAlertDestinationFormOptionsLazyQuery
>;
export type AlertDestinationFormOptionsSuspenseQueryHookResult = ReturnType<
  typeof useAlertDestinationFormOptionsSuspenseQuery
>;
export type AlertDestinationFormOptionsQueryResult = Apollo.QueryResult<
  AlertDestinationFormOptionsQuery,
  AlertDestinationFormOptionsQueryVariables
>;
export const AlertDestinationFormDetailsDocument = gql`
  query AlertDestinationFormDetails($destinationId: ID!) {
    getAlertDestinationDetails(alertDestinationId: $destinationId) {
      id
      name
      isDefault
      permittedToEdit
      permittedToDelete
      integrations {
        id
        kind
        organizationIntegrationId
        targetId
        targetLabel
      }
      members {
        id
        organizationMembershipId
        email
      }
      rules {
        id
        name
        server {
          name
        }
      }
    }
  }
`;

/**
 * __useAlertDestinationFormDetailsQuery__
 *
 * To run a query within a React component, call `useAlertDestinationFormDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertDestinationFormDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertDestinationFormDetailsQuery({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *   },
 * });
 */
export function useAlertDestinationFormDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertDestinationFormDetailsQuery,
    AlertDestinationFormDetailsQueryVariables
  > &
    (
      | { variables: AlertDestinationFormDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertDestinationFormDetailsQuery,
    AlertDestinationFormDetailsQueryVariables
  >(AlertDestinationFormDetailsDocument, options);
}
export function useAlertDestinationFormDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertDestinationFormDetailsQuery,
    AlertDestinationFormDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertDestinationFormDetailsQuery,
    AlertDestinationFormDetailsQueryVariables
  >(AlertDestinationFormDetailsDocument, options);
}
// @ts-ignore
export function useAlertDestinationFormDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertDestinationFormDetailsQuery,
    AlertDestinationFormDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AlertDestinationFormDetailsQuery,
  AlertDestinationFormDetailsQueryVariables
>;
export function useAlertDestinationFormDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertDestinationFormDetailsQuery,
        AlertDestinationFormDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AlertDestinationFormDetailsQuery | undefined,
  AlertDestinationFormDetailsQueryVariables
>;
export function useAlertDestinationFormDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AlertDestinationFormDetailsQuery,
        AlertDestinationFormDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AlertDestinationFormDetailsQuery,
    AlertDestinationFormDetailsQueryVariables
  >(AlertDestinationFormDetailsDocument, options);
}
export type AlertDestinationFormDetailsQueryHookResult = ReturnType<
  typeof useAlertDestinationFormDetailsQuery
>;
export type AlertDestinationFormDetailsLazyQueryHookResult = ReturnType<
  typeof useAlertDestinationFormDetailsLazyQuery
>;
export type AlertDestinationFormDetailsSuspenseQueryHookResult = ReturnType<
  typeof useAlertDestinationFormDetailsSuspenseQuery
>;
export type AlertDestinationFormDetailsQueryResult = Apollo.QueryResult<
  AlertDestinationFormDetailsQuery,
  AlertDestinationFormDetailsQueryVariables
>;
